/// <reference path="../types/index.d.ts" />

import '../client_forms/thecateredaffair2ham/style.css';
import FormStructure from './thecateredaffair2ham/form_structure';

export default FormStructure;